
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cotizacion/[step]",
      function () {
        return require("private-next-pages/cotizacion/[step].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cotizacion/[step]"])
      });
    }
  